import getCurrencies from 'api/currencies'
import { Formik } from 'formik'
import handleResponseError from 'forms/handleResponseError'
import { ICurrency } from 'interfaces/ICurrency'
import { useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { currenciesWithTranslations } from 'static/currencies'
import * as yup from 'yup'

import { useTranslation } from 'next-i18next'
import Link from 'next/link'

import ErrorMessage from 'components/ErrorMessage/ErrorMessage'
import Checkbox from 'components/Form/Checkbox/Checkbox'
import Form from 'components/Form/Form'
import Select from 'components/Form/Select/Select'
import SubmitButton from 'components/SubmitButton'

import styles from './GoogleForm.module.scss'

const GoogleForm = ({ onSubmit, error }) => {
  const [currencies, setCurrencies] = useState([])
  const [t] = useTranslation(['error', 'main'])
  useEffect(() => {
    const fetchCurrencies = async () => {
      const res = await getCurrencies()
      if (res.data.status !== 'success') {
        toast(handleResponseError(res))
      } else {
        const items: ICurrency[] = Object.values(res?.data?.payload?.items) || []
        setCurrencies(items)
      }
    }

    fetchCurrencies()
  }, [setCurrencies])
  const currencyFieldValues = useMemo(() => {
    return currencies
      .filter((item) => item.isCanRegistered)
      .map((item) => {
        const translationKey = currenciesWithTranslations.find(
          (currency) => currency.code === item.code,
        )?.translationKey
        return {
          name: translationKey ? t(translationKey) : item.name,
          value: item.id,
          icon: item.icon,
          label: item.code,
          countries: item.countries,
        }
      })
  }, [currencies, t])

  const initialValues = useMemo(() => {
    return {
      currency: undefined,
      agreement: true,
    }
  }, [])

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={yup.object({
        currency: yup
          .object()
          .required(t('error:requiredField'))
          .test({
            message: t('error:invalidCur'),
            test: (value: any) => {
              const idx = currencyFieldValues.findIndex((el) => el.value === value.value)
              const result = idx !== -1
              return result
            },
          }),
        agreement: yup.bool().equals([true], t('error:youMustAccept')),
      })}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => {
        return (
          <Form>
            <Select
              options={currencyFieldValues}
              name="currency"
              placeholder={t('main:signUpCurrency')}
            />
            <Checkbox name="agreement">
              {'  '}
              {t('main:confirmReadAcceptFirst')}{' '}
              <Link className={styles.link} target="_blank" href="/regulation/terms-and-conditions">
                {t('main:confirmReadAcceptSecond')}
              </Link>{' '}
              {t('main:confirmReadAcceptThird')}{' '}
              <Link className={styles.link} target="_blank" href="/regulation/privacy-policy">
                {t('main:confirmReadAcceptFouth')}
              </Link>
              .
            </Checkbox>

            {error && <ErrorMessage message={error} />}

            <SubmitButton isLoading={isSubmitting}>{t('main:googleSignUp')}</SubmitButton>
          </Form>
        )
      }}
    </Formik>
  )
}

export default GoogleForm
